<div
  class="left-right-list-title my-3"
  role="heading"
  [attr.aria-level]="ariaHeadingLevel"
  i18n="@@combinedAvailability-heading-libraryAvailability"
>
  Library availability
</div>

<rl-library-availability
  [resource]="resource"
  [physicalResources]="physicalAvailability"
  [digitisationLink]="digitisationLink"
  [item]="item"
  (onlineResourceClick)="onlineResourceClick.emit($event)"
>
</rl-library-availability>

<div
  class="left-right-list-title my-3 c-combined-availability__heading-alternative-availability"
  role="heading"
  [attr.aria-level]="ariaHeadingLevel"
  i18n="@@combinedAvailability-heading-alternativeAvailability"
  *ngIf="hasAlternativeAvailability"
>
  Alternative availability
</div>

<rl-bookstore-availability
  [bookstoreAvailability]="bookstoresAvailability"
  (onlineResourceClick)="onlineResourceClick.emit($event)"
>
</rl-bookstore-availability>
<ul *ngIf="showGooglePreviewButton" class="list-unstyled u-mb0 left-right-list">
  <li class="left-right-list__entry">
    <div class="bookstore-name">Google Books</div>
    <div class="bookstore-status">
      <rl-online-resource-button
        class="bookstore-status"
        [itemElementId]="itemElementId"
        [onlineResource]="onlineResource"
        (onlineResourceClick)="onlineResourceClick.emit($event)"
      >
      </rl-online-resource-button>
    </div>
  </li>
</ul>
